<template>
  <div>
    <div data-hover="" data-delay="0" class="dropdown w-dropdown">
      <div
        @click="switchOpen()"
        class="dropdown-toggle w-clearfix w-dropdown-toggle"
        :class="{ 'w--open': isOpen }"
        id="w-dropdown-toggle-2"
        aria-controls="w-dropdown-list-2"
        aria-haspopup="menu"
        aria-expanded="false"
        role="button"
        tabindex="0"
        style="outline: none"
      >
        <div class="icon w-icon-dropdown-toggle"></div>
        <div class="chap-num">{{ chapterIndex + 1 + ". " }}</div>
        <div>{{ chapter.title }}</div>
      </div>
      <nav
        class="dropdown-list w-dropdown-list"
        :class="{ 'w--open': isOpen }"
        v-for="(item, i) in chapterLessons.filter((c) => c.active)"
        :key="item._id"
      >
        <router-link
          :to="{
            name: 'LessonBody',
            params: { chapterID: chapter._id, lessonID: item._id },
          }"
          class="dropdown-link w-dropdown-link"
        >
          <span class="less-num">{{ i + 1 + ". " }}</span
          ><span v-on:click="setChapter(chapter)">{{ item.title }}</span>
        </router-link>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "expansion_widget",
  data: function () {
    return {
      isOpen: false,
      chapterLessons: [],
    };
  },
  props: {
    chapter: Object,
    chapterIndex: Number,
  },
  methods: {
    switchOpen() {
      this.isOpen = !this.isOpen;
    },
    orderNum(ordNum) {
      return ordNum + 1;
    },
    async setChapter(chapter) {
      await this.$store.commit("setChapter", chapter);
    },
  },
  async mounted() {
    this.chapterLessons = await this.$store.dispatch(
      "fetchLessonsOfChapter",
      this.chapter._id
    );
  },
  computed: {
    path() {
      return this.$store.getters.getSelectedPath._id;
    },
  },
};
</script>

<style scoped>
.less-num {
}
.chap-num {
  margin-right: -27px;
  float: right;
  font-weight: 600;
}
.dropdown-toggle {
  padding-right: 50px;
  padding-left: 50px;
}
.icon {
  margin-left: -30px;
}
</style>
